import React, { useEffect } from "react";
import styled from "styled-components";
import { isMobile } from "../common/style";

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
    Kakao: any;
  }
}

type FoodType = {
  food: string;
};

const ShareKakao: React.FC<FoodType> = ({ food }) => {
  const url = "https://today-eat.netlify.app";

  useEffect(() => {
    ShareKakao();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ShareKakao = () => {
    if (window.Kakao) {
      const kakao = window.Kakao;
      if (!kakao.isInitialized()) {
        kakao.init(process.env.REACT_APP_KAKAO_KEY);
      }
      kakao.Share.createDefaultButton({
        container: "#kakao-link-btn",
        objectType: "feed",
        content: {
          title: "오늘 뭐 먹지?",
          description: "우리 오늘 " + food + " 먹자!",
          imageUrl: "https://i.ibb.co/TRkJZ0N/image.png",
          link: {
            webUrl: url,
            mobileWebUrl: url,
          },
        },
        buttons: [
          {
            title: "다른거 먹자",
            link: {
              webUrl: url,
            },
          },
        ],
      });
    }
  };

  return <ShareBtn id="kakao-link-btn">공유하기</ShareBtn>;
};

export default ShareKakao;

const ShareBtn = styled.button`
  width: 149px;
  height: 56px;
  border-radius: 100px;
  border: 3px solid #7d5959;
  background: #fff5f5;
  color: #7d5959;
  font-family: GmarketSansBold;
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 10px;
  line-height: 50px;
  cursor: pointer;

  ${isMobile} {
    width: 140px;
    height: 50px;
    font-size: 20px;
    margin-bottom: 7px;
    border: 2px solid #7d5959;
    line-height: 48px;
  }

  &:hover {
    background: #ebcece;
  }
`;
